<template >
  <div>

    <Head>
      <Title>{{ pageTitle }}</Title>
      <Meta name="description" :content="props.descr ? props.descr : descrDefault" />
      <Meta property="og:url" :content="url_atual" />
      <Meta property="og:site_name" :content="panelPageTitle?.value || (props.titulo_seo ? props.titulo_seo + ' - ' + sitenameDefault : sitenameDefault)" />
      <Meta property="og:type" content="website" />
      <Meta property="og:title" :content="panelPageTitle?.value || (props.titulo_seo ? props.titulo_seo + ' - ' + sitenameDefault : titleDefault)" />
      <Meta property="og:image:alt" :content="props.titulo_seo ? props.titulo_seo : sitenameDefault" />
      <Meta property="og:description" :content="props.descr ? props.descr : descrDefault" />
      <Meta property="og:image" :content="props.img ? domain + props.img : domain + imgDefault" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" :content="domain" />
      <meta property="twitter:url" :content="url_atual" />
      <meta name="twitter:title" content="titulo_seo ? titulo_seo + ' - ' + sitenameDefault : sitenameDefault" />
      <meta name="[twitter:title]" :content="props.descr ? props.descr : descrDefault" />
      <meta name="twitter:image" :content="props.img ? domain + props.img : domain + imgDefault" />

      <link rel="shortcut icon" href="/assets/favicon/favicon.ico">

      <link rel="apple-touch-icon" sizes="57x57" href="/assets/favicon/apple-icon-57x57.png">
      <link rel="apple-touch-icon" sizes="60x60" href="/assets/favicon/apple-icon-60x60.png">
      <link rel="apple-touch-icon" sizes="72x72" href="/assets/favicon/apple-icon-72x72.png">
      <link rel="apple-touch-icon" sizes="76x76" href="/assets/favicon/apple-icon-76x76.png">
      <link rel="apple-touch-icon" sizes="114x114" href="/assets/favicon/apple-icon-114x114.png">
      <link rel="apple-touch-icon" sizes="120x120" href="/assets/favicon/apple-icon-120x120.png">
      <link rel="apple-touch-icon" sizes="144x144" href="/assets/favicon/apple-icon-144x144.png">
      <link rel="apple-touch-icon" sizes="152x152" href="/assets/favicon/apple-icon-152x152.png">
      <link rel="apple-touch-icon" sizes="180x180" href="/assets/favicon/apple-icon-180x180.png">
      <link rel="icon" type="image/png" sizes="192x192" href="/assets/favicon/android-icon-192x192.png">
      <link rel="icon" type="image/png" sizes="32x32" href="/assets/favicon/favicon-32x32.png">
      <link rel="icon" type="image/png" sizes="96x96" href="/assets/favicon/favicon-96x96.png">
      <link rel="icon" type="image/png" sizes="16x16" href="/assets/favicon/favicon-16x16.png">
      <link rel="manifest" href="/assets/favicon/manifest.json">
      <meta name="msapplication-TileColor" content="#ffffff">
      <meta name="msapplication-TileImage" content="/assets/favicon/ms-icon-144x144.png">
    </Head>
  </div>
</template>

<script setup>
const props = defineProps(['titulo', 'titulo_seo', 'descr', 'img'])

const runtimeConfig = useRuntimeConfig();
const route = useRoute()

const titleDefault = runtimeConfig.public.NUXT_SEO_TITLE
const sitenameDefault = runtimeConfig.public.NUXT_SEO_SITE_NAME
const imgDefault = runtimeConfig.public.NUXT_SEO_IMG
const descrDefault = runtimeConfig.public.NUXT_SEO_DESCR
const apidomain = runtimeConfig.public.NUXT_API_BACK_URL
const domain = runtimeConfig.public.NUXT_DOMAIN
const url_atual = domain + route.path
const panelPageTitle = route.path.startsWith('/painel') ? await usePanelPageTitle() : null;
const pageTitle = computed(() => {
  if (panelPageTitle?.value) return panelPageTitle.value;
  return props.titulo ? `${props.titulo} - ${sitenameDefault}` : sitenameDefault;
});

useHead({
  link: [
    {
      rel: 'icon',
      type: 'image/png',
      href: '/assets/favicon/favicon.ico'
    }
  ]
})

</script>


<style >

</style>
